import React, { memo } from "react";
import { Box, Checkbox, Count } from "@bca/ui-library";
import { SpaceProps } from "styled-system";

export interface FilterItemProps extends SpaceProps {
  id: string;
  label: string;
  resultsCount?: number;
  onChange?: () => void;
  isSelected: boolean;
  isDisabled?: boolean;
}

const FilterAsCheckbox = ({
  id,
  label,
  resultsCount,
  onChange,
  isSelected,
  isDisabled = false,
  ...props
}: FilterItemProps) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    mb={3}
    {...props}
  >
    <Checkbox
      id={id}
      data-testid={id}
      checked={isSelected}
      onChange={onChange}
      label={label}
      disabled={isDisabled}
    />
    {resultsCount && (
      <Count
        variant={isSelected ? "active" : "default"}
        number={resultsCount}
      ></Count>
    )}
  </Box>
);

export default memo(FilterAsCheckbox);
